<template>
    <div>
        <div class="module">
            <div class="module-tit">
                <img src="../../static/images/2.png" alt="">
                <span>收入</span>
            </div>
            <ul class="module-ul">
                <li class="module-li">
                    <span class="module-li-tit">
                        税前工资（月）
                        <i class="icon iconfont icon-bangzhu-" @click="isShowGongzi = !isShowGongzi"></i>
                    </span>
                    <input v-model.lazy="gongzi" @change="gongziChange" class="module-li-short" type="text">
                    <span>元</span>
                    <div v-show="isShowGongzi" class="explain">
                        <i class="icon iconfont icon-guanbi" @click="isShowGongzi = false"></i>
                        <h1>税前工资：</h1>
                        <p>是指个人因任职或者受雇取得的工资、薪金、奖金、年终加薪、劳动分红、津贴、补贴以及与任职或者受雇有关的其他所得</p>
                    </div>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">年终奖</span>
                    <input v-model.lazy="nianzhongjiang" @change="nianzhongjiangChange" class="module-li-short" type="text">
                    <span>元</span>
                </li>
            </ul>
        </div>
        <div class="module">
            <div class="module-tit">
                <img src="../../static/images/2.png" alt="">
                <span>五险一金</span>
                <input v-model="allCheckbox" id="all" type="checkbox">
                <label for="all">总数</label>
            </div>
            <ul class="module-ul">
                <li class="module-li">
                    <span class="module-li-tit">基本养老保险</span>
                    <input v-model.lazy="jbyanglao" @change="jbyanglaoChange" class="module-li-short" type="text" :disabled="allCheckbox">
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">
                        补充养老保险
                        <i class="icon iconfont icon-bangzhu-" @click="isShowBcyanglao = !isShowBcyanglao"></i>
                    </span>
                    <input v-model.lazy="bcyanglao" @change="bcyanglaoChange" class="module-li-short" type="text" :disabled="allCheckbox">
                    <span>元</span>
                    <div v-show="isShowBcyanglao" class="explain">
                        <i class="icon iconfont icon-guanbi" @click="isShowBcyanglao = false"></i>
                        <h1>补充养老保险：</h1>
                        <p>企业年金或职业年金</p>
                    </div>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">基本医疗保险</span>
                    <input v-model.lazy="jbyiliao" @change="jbyiliaoChange" class="module-li-short" type="text" :disabled="allCheckbox">
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">补充医疗保险</span>
                    <input v-model.lazy="bcyiliao" @change="bcyiliaoChange" class="module-li-short" type="text" :disabled="allCheckbox">
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">失业保险</span>
                    <input v-model.lazy="shiye" @change="shiyeChange" class="module-li-short" type="text" :disabled="allCheckbox">
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">住房公积金</span>
                    <input v-model.lazy="gongjijin" @change="gongjijinChange" class="module-li-short" type="text" :disabled="allCheckbox">
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">总数</span>
                   <!--真是输入的总数-->
                    <input v-show="allCheckbox" v-model.lazy="allNum" @change="allNumChange" class="module-li-short" type="text" :disabled="!allCheckbox">
                    <!--五险一金合计算出的总数，仅显示-->
                    <input v-show="!allCheckbox" v-model="_allNum" class="module-li-short" type="text" :disabled="!allCheckbox">
                    <span>元</span>
                </li>
            </ul>
        </div>
        <div class="module">
            <div class="module-tit">
                <img src="../../static/images/2.png" alt="">
                <span>专项附加扣除</span>
            </div>
            <ul class="module-ul">
                <li class="module-subheading">
                    <span>
                        子女教育
                        <i class="icon iconfont icon-bangzhu-" @click="isShowZnjiaoyu = !isShowZnjiaoyu"></i>
                    </span>
                    <div v-show="isShowZnjiaoyu" class="explain">
                        <i class="icon iconfont icon-guanbi" @click="isShowZnjiaoyu = false"></i>
                        <h1>子女教育：</h1>
                        <p>子女3岁至博士研究生教育阶段的支出，按照每个子女每年12000元（每月1000元）的标准定额扣除</p>
                    </div>
                </li>
                <li class="module-li-choice">
                    <div @click="isSingle = !isSingle" :class="{selected : isSingle}" class="choice" >
                        单个子女1000/月
                    </div>
                </li>
                <li class="module-li-choice">
                    <input v-model.lazy="childNum" @change="childNumChange" class='choice-input' type="number" placeholder="请输入子女个数">
                </li>
                <li class="module-li-choice">
                    <div @click="isWhole = !isWhole;isHalf = !isWhole" :class="{selected : isWhole}" class="choice">
                        夫妻一方扣除100%
                    </div>
                </li>
                <li class="module-li-choice">
                    <div @click="isHalf = !isHalf;isWhole = !isHalf " :class="{selected : isHalf}" class="choice">
                        夫妻各扣除50%
                    </div>
                </li>
                <li class="module-subheading">
                    <span>
                        继续教育
                        <i class="icon iconfont icon-bangzhu-" @click="isShowJxjiaoyu = !isShowJxjiaoyu"></i>
                    </span>
                    <div v-show="isShowJxjiaoyu" class="explain">
                        <i class="icon iconfont icon-guanbi" @click="isShowJxjiaoyu = false"></i>
                        <h1>继续教育：</h1>
                        <p>接受学历继续教育，按照每年4800元（每月400元）定额扣除；接受职业资格继续教育，在取得相关证书的年度，按照每年3600元定额扣除</p>
                    </div>
                </li>
                <li class="module-li-choice">
                    <div @click="isEducation = !isEducation" :class="{selected : isEducation}" class="choice">
                        学历教育 400元
                    </div>
                </li>
                <li class="module-li-choice">
                    <div @click="isOccupation = !isOccupation" :class="{selected : isOccupation}" class="choice">
                        职业资格教育 3600元
                    </div>
                </li>
                <li class="module-subheading">
                    <span>
                        房贷/租房
                        <i class="icon iconfont icon-bangzhu-" @click="isShowFangdai = !isShowFangdai"></i>
                    </span>
                    <div v-show="isShowFangdai" class="explain">
                        <i class="icon iconfont icon-guanbi" @click="isShowFangdai = false"></i>
                        <h1>住房贷款利息：</h1>
                        <p>首套住房贷款利息支出，在偿还贷款期间，可以按照每年12000元（每月1000元）标准定额扣除（不能与住房租金同时扣除）</p>
                    </div>
                </li>
                <li class="module-li-choice">
                    <div @click="isHousingLoan = !isHousingLoan" :class="{selected : isHousingLoan}" class="choice">
                        首套住房贷款利息 1000元
                    </div>
                </li>
                <li class="module-li-choice">
                    <div @click="isCity = !isCity" :class="{selected : isCity}" class="choice">
                        直辖市、省会城市 1500元
                    </div>
                </li>
                <li class="module-li-choice">
                    <div @click="isExceedMillion = !isExceedMillion" :class="{selected : isExceedMillion}" class="choice">
                        市辖区户籍人口超过100万 1100元
                    </div>
                </li>
                <li class="module-li-choice">
                    <div @click="unExceedMillion = !unExceedMillion" :class="{selected : unExceedMillion}" class="choice">
                        市辖区人口不超过100万（含）800元
                    </div>
                </li>
                <li class="module-subheading">
                    <span>
                        赡养老人（60岁以上）
                        <i class="icon iconfont icon-bangzhu-" @click="isShowShanyanglaoren = !isShowShanyanglaoren"></i>
                    </span>
                    <div v-show="isShowShanyanglaoren" class="explain">
                        <i class="icon iconfont icon-guanbi" @click="isShowShanyanglaoren = false"></i>
                        <h1>赡养老人：</h1>
                        <p>赡养2个及以上老人的，不按老人人数加倍扣除</p>
                    </div>
                </li>
                <li class="module-li-choice">
                    <div @click="unOne = !unOne" :class="{selected : unOne}" class="choice">
                        非独生子女
                    </div>
                </li>
                <li class="module-li-choice">
                    <div @click="isOne = !isOne" :class="{selected : isOne}" class="choice">
                        独生子女 2000元
                    </div>
                </li>
                <li class="module-li">
                     <span class="module-li-tit">
                         手动输入分摊金额
                    </span>
                    <input v-model.lazy="unOnlyMoney" @change="unOnlyMoneyChange" class="module-li-short" type="text" placeholder="金额最高不得超过1000元" :disabled="!unOne">
                    <span>元</span>
                </li>
                <li class="module-li">

                </li>
            </ul>
        </div>
        <div class="module">
            <div class="module-tit">
                <img src="../../static/images/2.png" alt="">
                <span>其他扣除</span>
            </div>
            <ul class="module-ul">
                <li class="module-li">
                    <span class="module-li-tit">免税所得</span>
                    <input v-model.lazy="mianshuisuode" @change="mianshuisuodeChange" class="module-li-short" type="text">
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">
                        商业健康保险
                        <i class="icon iconfont icon-bangzhu-" @click="isShowShangye = !isShowShangye"></i>
                    </span>
                    <input v-model.lazy="shangyejaingkang" @change="shangyejaingkangChange" class="module-li-short" type="text">
                    <span>元</span>
                    <div v-show="isShowShangye" class="explain">
                        <i class="icon iconfont icon-guanbi" @click="isShowShangye = false"></i>
                        <h1>商业健康保险：</h1>
                        <p>按200元的上限扣除</p>
                    </div>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">
                        捐赠
                        <i class="icon iconfont icon-bangzhu-" @click="isShowJuanzeng = !isShowJuanzeng"></i>
                    </span>
                    <input v-model.lazy="juanzeng" @change="juanzengChange" class="module-li-short" type="text">
                    <span>元</span>
                    <div v-show="isShowJuanzeng" class="explain">
                        <i class="icon iconfont icon-guanbi" @click="isShowJuanzeng = false"></i>
                        <h1>捐赠：</h1>
                        <p>捐赠额未超过纳税人申报的应纳税所得额百分之三十的部分，可以从其应纳税所得额中扣除</p>
                    </div>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">其他扣除</span>
                    <input v-model.lazy="qitakouchu" @change="qitakouchuChange" class="module-li-short" type="text">
                    <span>元</span>
                </li>
            </ul>
        </div>
        <div class="btn" @click="computerClick">
            计算
        </div>
        <div class="module">
            <div class="module-tit">
                <img src="../../static/images/2.png" alt="">
                <span>计算结果</span>
            </div>
            <ul class="module-ul">
                <li class="module-li">
                    <span class="module-li-tit">税前收入</span>
                    <input v-model="beforeIncome" class="module-li-short" type="text" readonly>
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">应纳税额</span>
                    <input v-model="taxAmount" class="module-li-short" type="text" readonly>
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">
                        税后收入
                        <i class="icon iconfont icon-bangzhu-" @click="isShowShuihoushouru = !isShowShuihoushouru"></i>
                    </span>
                    <input v-model="afterIncome" class="module-li-short" type="text" readonly>
                    <span>元</span>
                    <div v-show="isShowShuihoushouru" class="explain">
                        <i class="icon iconfont icon-guanbi" @click="isShowShuihoushouru = false"></i>
                        <h1>税后收入：</h1>
                        <p>即实际到手工资，等于税前工资+年终奖+劳务报酬+稿酬+特许权使用费-社保、公积金-专项附加扣除-应纳税额</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import number from '../../static/js/number'
    import unNumber from '../../static/js/unNumber'
    export default {
        data(){
            return{
                gongzi:'0',//税前工资
                nianzhongjiang:'0',//年终奖
                jbyanglao:'0',//基本养老保险
                bcyanglao:'0',//补充养老保险
                jbyiliao:'0',//基本医疗保险
                bcyiliao:'0',//补充医疗保险
                shiye:'0',//失业保险
                gongjijin:'0',//住房公积金
                allNum:'0',//五险一金总数
                childNum:'',//输入的子女个数
                unOnlyMoney:'',//非独生子女输入金额
                mianshuisuode:'0',//免税所得
                shangyejaingkang:'0',//商业健康
                juanzeng:'0',//捐赠
                qitakouchu:'0',//其他扣除
                allCheckbox:false,//五险一金总数

                isSingle:false,//是否选择单个子女
                isWhole:true,// 夫妻一方扣除100%
                isHalf:false,//夫妻各扣除50%
                isEducation:false,//学历教育
                isOccupation:false,//学历教育

                isHousingLoan:false,//填写首套住房贷款利息
                isCity:false,//直辖市、省会城市
                isExceedMillion:false,//市辖区户籍人口超过100万
                unExceedMillion:false,//市辖区人口不超过100万（含）

                isOne:false,//独生子女
                unOne:false,//非独生子女

                isShowGongzi:false,//是否显示工资说明
                isShowBcyanglao:false,//是否显示补充养老保险说明
                isShowZnjiaoyu:false,//是否显示子女教育说明
                isShowJxjiaoyu:false,//是否显示继续教育说明
                isShowFangdai:false,//是否显示房贷/租房说明
                isShowShanyanglaoren:false,//是否显示赡养老人说明
                isShowShangye:false,//是否显示商业健康保险说明
                isShowJuanzeng:false,//是否显示捐赠说明
                isShowShuihoushouru:false,//是否显示税后收入说明

                beforeIncome:0,//税前收入
                taxAmount:0,//应纳税额
                afterIncome:0,//税后收入
            }
        },
        watch:{
            isHousingLoan:function(val){
                if(val){
                    this.isCity = false
                    this.isExceedMillion = false
                    this.unExceedMillion = false
                }
            },
            isCity:function(val){
                if(val){
                    this.isHousingLoan = false
                    this.isExceedMillion = false
                    this.unExceedMillion = false
                }
            },
            isExceedMillion:function(val){
                if(val){
                    this.isHousingLoan = false
                    this.isCity = false
                    this.unExceedMillion = false
                }
            },
            unExceedMillion:function(val){
                if(val){
                    this.isHousingLoan = false
                    this.isExceedMillion = false
                    this.isCity = false
                }
            },
            isOne:function(val){
                if(val)this.unOne = false
            },
            unOne:function(val){
                if(val)this.isOne = false
            },
        },
        computed:{
            _allNum:function(){
                    let jbyanglao = unNumber.unNumber(this.jbyanglao)//基本养老保险
                    let bcyanglao = unNumber.unNumber(this.bcyanglao)//补充养老保险
                    let jbyiliao = unNumber.unNumber(this.jbyiliao)//基本医疗保险
                    let bcyiliao = unNumber.unNumber(this.bcyiliao)//补充医疗保险
                    let shiye = unNumber.unNumber(this.shiye)//失业保险
                    let gongjijin = unNumber.unNumber(this.gongjijin)//住房公积金
                    return number.number((jbyanglao + bcyanglao + jbyiliao - bcyiliao + shiye + gongjijin).toFixed(2))
            }
        },
        methods:{
            gongziChange(){
                let val = unNumber.unNumber(this.gongzi)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.gongzi = '0.00'
                }else{
                    this.gongzi = number.number(this.gongzi)
                }
            },
            nianzhongjiangChange(){
                let val = unNumber.unNumber(this.nianzhongjiang)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.nianzhongjiang = '0.00'
                }else{
                    this.nianzhongjiang = number.number(this.nianzhongjiang)
                }
            },
            texuChange(){
                let val = unNumber.unNumber(this.texu)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.texu = '0.00'
                }else{
                    this.texu = number.number(this.texu)
                }
            },
            jbyanglaoChange(){
                let val = unNumber.unNumber(this.jbyanglao)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.jbyanglao = '0.00'
                }else{
                    this.jbyanglao = number.number(this.jbyanglao)
                }
            },
            bcyanglaoChange(){
                let val = unNumber.unNumber(this.bcyanglao)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.bcyanglao = '0.00'
                }else{
                    this.bcyanglao = number.number(this.bcyanglao)
                }
            },
            jbyiliaoChange(){
                let val = unNumber.unNumber(this.jbyiliao)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.jbyiliao = '0.00'
                }else{
                    this.jbyiliao = number.number(this.jbyiliao)
                }
            },
            bcyiliaoChange(){
                let val = unNumber.unNumber(this.bcyiliao)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.bcyiliao = '0.00'
                }else{
                    this.bcyiliao = number.number(this.bcyiliao)
                }
            },
            shiyeChange(){
                let val = unNumber.unNumber(this.shiye)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.shiye = '0.00'
                }else{
                    this.shiye = number.number(this.shiye)
                }
            },
            gongjijinChange(){
                let val = unNumber.unNumber(this.gongjijin)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.gongjijin = '0.00'
                }else{
                    this.gongjijin = number.number(this.gongjijin)
                }
            },
            allNumChange(){
                let val = unNumber.unNumber(this.allNum)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.allNum = '0.00'
                }else{
                    this.allNum = number.number(this.allNum)
                }
            },
            unOnlyMoneyChange(){
                let val = unNumber.unNumber(this.unOnlyMoney)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.unOnlyMoney = '0.00'
                }else{
                    this.unOnlyMoney = number.number(this.unOnlyMoney)
                }
            },
            mianshuisuodeChange(){
                let val = unNumber.unNumber(this.mianshuisuode)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.mianshuisuode = '0.00'
                }else{
                    this.mianshuisuode = number.number(this.mianshuisuode)
                }
            },
            shangyejaingkangChange(){
                let val = unNumber.unNumber(this.shangyejaingkang)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.shangyejaingkang = '0.00'
                }else{
                    this.shangyejaingkang = number.number(this.shangyejaingkang)
                }
            },
            juanzengChange(){
                let val = unNumber.unNumber(this.juanzeng)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.juanzeng = '0.00'
                }else{
                    this.juanzeng = number.number(this.juanzeng)
                }
            },
            qitakouchuChange(){
                let val = unNumber.unNumber(this.qitakouchu)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.qitakouchu = '0.00'
                }else{
                    this.qitakouchu = number.number(this.qitakouchu)
                }
            },


            childNumChange(){
                var str = /^\d+$/;//判断只允许输入正整数
                if(!str.test(this.childNum)){
                    this.childNum = parseFloat(this.childNum).toFixed(0);
                }else{
                }
            },
            computerClick(){
                let gongzi = unNumber.unNumber(this.gongzi)//税前工资
                let nianzhongjiang = unNumber.unNumber(this.nianzhongjiang)//年终奖
                let allNum = unNumber.unNumber(this.allNum)//五险一金总数 勾选了总数时数据有效
                let _allNum = unNumber.unNumber(this._allNum)//五险一金总数 没有勾选总数时数据有效
                let childNum = Number(this.childNum) > 0 ? Number(this.childNum) : 0//输入的子女个数
                let unOnlyMoney = unNumber.unNumber(this.unOnlyMoney)//非独生子女输入金额
                let mianshuisuode = unNumber.unNumber(this.mianshuisuode)//免税所得
                let shangyejaingkang = unNumber.unNumber(this.shangyejaingkang) > 200 ? 200 : unNumber.unNumber(this.shangyejaingkang)//商业健康
                let juanzeng = unNumber.unNumber(this.juanzeng)//捐赠;
                let juanzengNew = 0
                let qitakouchu = unNumber.unNumber(this.qitakouchu)//其他扣除

                let wuxianyijin = 0;//五险一金合计
                let singleMoney = 0//子女教育人数
                let educationMoney = 0//继续教育
                let roomRate = 0//房贷/租房
                let childrenMoney = 0//独生子女费
                let x = 0;
                let y1 = 0;
                let y2 = 0;
                let taxY1 = 0//y1税率
                let taxY2 = 0//y2税率



                //判断五险一金是否选择总数
                if(this.allCheckbox){
                    wuxianyijin = allNum
                }else{
                    wuxianyijin = _allNum
                }

                //判断专属附加税
                //子女教育人数
                if(this.isSingle){
                    singleMoney = this.isWhole ? 1000 : 500
                }else{
                    if(childNum){
                        singleMoney = this.isWhole ? childNum * 1000 : childNum * 500
                    }else{
                        singleMoney = 0
                    }
                }
                //继续教育
                educationMoney += Number(this.isEducation ? 400 : 0)
                educationMoney += Number(this.isOccupation ? 3600 : 0)
                //房贷/租房
                roomRate = this.isHousingLoan ? 1000 :
                    this.isCity ? 1500 :
                        this.isExceedMillion ? 1100 :
                            this.unExceedMillion ? 800 : 0
                //独生子女
                if(this.isOne){
                    childrenMoney = 2000;
                }else{
                    if(this.unOne && unOnlyMoney){
                        childrenMoney = unOnlyMoney > 1000 ? 1000 : unOnlyMoney
                    }
                }
                x = gongzi - wuxianyijin - singleMoney - educationMoney - roomRate - childrenMoney - mianshuisuode - shangyejaingkang - qitakouchu
                //liukun
                //计算捐赠
                juanzengNew = juanzeng > x * 0.3 ? x * 0.3 : juanzeng
                console.log(x - juanzengNew - 5000);
                y1 = (x - juanzengNew - 5000) > 0 ? (x - juanzengNew - 5000) : 0
                if(nianzhongjiang){
                    y2 = nianzhongjiang / 12
                }
                taxY1 = this.tax1(y1);
                taxY2 = this.tax2(y2,nianzhongjiang);
                console.log(x,'x');
                console.log(y1,'y1');
                console.log(y2,'y2');
                console.log(taxY1,'y1税率');
                console.log(taxY2,'y2税率');
                this.taxAmount = taxY1 + taxY2 > 0 ? taxY1 + taxY2 : 0
                this.afterIncome = gongzi + nianzhongjiang - (this.allCheckbox ? allNum : _allNum) - juanzeng - this.taxAmount


                this.beforeIncome = number.number((gongzi + nianzhongjiang).toFixed(2))
                this.taxAmount = number.number((this.taxAmount).toFixed(2))
                this.afterIncome = this.afterIncome > 0 ? number.number((this.afterIncome).toFixed(2)) : 0
            },
            tax1(n){
                return n <= 3000 ? ( n * 0.03) :
                    n <= 12000 ? ( n * 0.1 - 210) :
                        n <= 25000 ? ( n * 0.2 - 1410) :
                            n <= 35000 ? ( n * 0.25 - 2660) :
                                n <= 55000 ? ( n * 0.3 -4410) :
                                    n <= 80000 ? ( n * 0.35 - 7160) : ( n * 0.45 - 15160)
            },
            tax2(n,m){
                console.log(n,'n');
                console.log(m,'m');
                return n <= 3000 ? (m * 0.03) :
                    n <= 12000 ? (m * 0.1 - 210) :
                        n <= 25000 ? (m * 0.2 - 1410) :
                            n <= 35000 ? (m * 0.25 - 2660) :
                                n <= 55000 ? (m * 0.3 -4410) :
                                    n <= 80000 ? (m * 0.35 - 7160) : (m * 0.45 - 15160)
            }
        },
        mounted(){

        }
    }
</script>
<style scoped>
    .module{
        width:100%;
        margin-top: 30px;
        text-align: left;
    }
    .module .module-tit{
        display: inline-block;
        border-bottom: 1px solid #1a96d4;
        padding: 5px 15px 5px 10px;
        font-size:16px;
    }
    .module .module-tit #all{
        width:16px;
        height:16px;
    }
    .module .module-ul{
        width:100%;
        font-size:0;
    }
    .module .module-ul .module-li{
        display: inline-block;
        width:50%;
        height:36px;
        font-size:14px;
        color: #333;
        margin-top:20px;
        position: relative;
    }
    .module .module-ul .module-li .module-li-tit{
        display: inline-block;
        width:140px;
        height:100%;
        font-size: 14px;
        margin-left: 20px;
        margin-right: 10px;
        vertical-align: middle;
    }
    .module .module-ul .module-li .module-li-tit .icon-bangzhu-{
        display: inline-block;
        float: right;
        font-size:20px;
        color: #1a96d4;
        cursor: pointer;
        vertical-align: middle;
    }
    .module .module-ul .module-li .module-li-short{
        display: inline-block;
        width:270px;
        height:32px;
        line-height: 1;
        font-size:14px;
        text-align: center;
        border: 1px solid #b9e9f2;
    }
    .module .module-ul .module-li .explain{
        display: block;
        width:500px;
        position: absolute;
        border: 1px solid #1a96d4;
        border-radius: 10px;
        top:36px;
        left:0px;
        background-color: #fff;
        z-index:100;
        padding: 10px 20px;
        box-shadow:5px 5px 20px -5px #ccc
    }
    .module .module-ul .module-li .explain .icon-guanbi{
        position: absolute;
        top:5px;
        right:5px;
        font-size:20px;
        cursor: pointer;
    }
    .module .module-ul .module-li .explain h1{
        font-size:20px;
        color: #333;
    }
    .module .module-ul .module-li .explain p{
        font-size:18px;
        color: #333;
    }
    .module .module-ul .module-li-choice .choice.selected{
        border: 1px solid #1a96d4;
        color: #1a96d4;
        background-color: #d1edf8;
    }
    .module .module-ul .module-subheading{
        width:100%;
        border-bottom: 1px solid #ccc;
        padding: 10px 0;
        position: relative;
    }
    .module .module-ul .module-subheading span{
        font-size:14px;
        color: #333;
        border-left:1px solid #1a96d4;
        padding-left: 10px;
    }
    .module .module-ul .module-subheading span .icon-bangzhu-{
        display: inline-block;
        font-size:20px;
        color: #1a96d4;
        cursor: pointer;
        vertical-align: middle;
    }
    .module .module-ul .module-subheading .explain{
        display: block;
        width:500px;
        position: absolute;
        border: 1px solid #1a96d4;
        border-radius: 10px;
        top:36px;
        left:0px;
        background-color: #fff;
        z-index:100;
        padding: 10px 20px;
        box-shadow:5px 5px 20px -5px #ccc
    }
     .module .module-ul .module-subheading .explain .icon-guanbi{
        position: absolute;
        top:5px;
        right:5px;
        font-size:20px;
        cursor: pointer;
    }
     .module .module-ul .module-subheading .explain h1{
        font-size:20px;
        color: #333;
    }
     .module .module-ul .module-subheading .explain p{
        font-size:18px;
        color: #333;
    }
    .module .module-ul .module-li-choice{
        display: inline-block;
        width:50%;
        height:36px;
        font-size:14px;
        color: #333;
        margin-top:20px;
    }
    .module .module-ul .module-li-choice .choice{
        width:440px;
        height:32px;
        border: 1px solid #ccc;
        text-align: center;
        line-height: 32px;
        color: #333;
        margin-left: 10px;
        cursor: pointer;
    }
    .module .module-ul .module-li-choice .choice-input{
        width:440px;
        height:32px;
        border: 1px solid #b9e9f2;
        text-align: center;
        line-height: 32px;
        color: #333;
        margin-left: 10px;
    }
    .btn{
        display: inline-block;
        width: 224px;
        height: 42px;
        font-size:22px;
        color: #fff;
        background-color: #13b5ea;
        text-align: center;
        line-height: 42px;
        border-radius: 3px;
        margin-top: 40px;
        cursor: pointer;
    }
    @media screen and (max-width:768px) {
        .module{
            width:100%;
            margin-top: 0.1rem;
        }
        .module .module-tit{
            display: inline-block;
            border-bottom: 1px solid #1a96d4;
            padding: 0.05rem 0.15rem 0.05rem 0.1rem;
            font-size:0.3rem;
        }
        .module .module-tit img{
            width:0.3rem;
            height:0.3rem;
        }
        .module .module-tit #all{
            width:0.3rem;
            height:0.3rem;
        }
        .module .module-ul{
            width:100%;
            font-size:0;
        }
        .module .module-ul .module-li{
            display: inline-block;
            width:100%;
            height:0.6rem;
            font-size:0.24rem;
            margin-top:0.2rem;
        }
        .module .module-ul .module-li .module-li-tit{
            display: inline-block;
            width:2.3rem;
            height:100%;
            font-size: 0.24rem;
            margin-left: 0rem;
            margin-right: 0.1rem;
        }
        .module .module-ul .module-li .module-li-tit .icon-bangzhu-{
            display: inline-block;
            float: right;
            font-size:0.3rem;
            color: #1a96d4;
            cursor: pointer;
            vertical-align: middle;
        }
        .module .module-ul .module-li .module-li-short{
            display: inline-block;
            width:2.6rem;
            height:100%;
            font-size:0.24rem;
            border: 1px solid #b9e9f2;
        }
        .module .module-ul .module-li .explain{
            display: block;
            width:5rem;
            position: absolute;
            border: 1px solid #1a96d4;
            border-radius: 10px;
            top:0.6rem;
            left:0;
            background-color: #fff;
            z-index:100;
            padding: 0.1rem 0.2rem;
            box-shadow:5px 5px 20px -5px #ccc
        }
        .module .module-ul .module-li .explain .icon-guanbi{
            position: absolute;
            top:5px;
            right:5px;
            font-size:0.3rem;
            cursor: pointer;
        }
        .module .module-ul .module-li .explain h1{
            font-size:0.3rem;
            color: #333;
        }
        .module .module-ul .module-li .explain p{
            font-size:0.24rem;
            color: #333;
        }
        .module .module-ul .module-subheading{
            width:100%;
            border-bottom: 1px solid #ccc;
            padding: 0.2rem 0;
        }
        .module .module-ul .module-subheading span{
            font-size:0.24rem;
            padding-left: 0.2rem;
        }
        .module .module-ul .module-subheading span .icon-bangzhu-{
            display: inline-block;
            font-size:0.3rem;
            color: #1a96d4;
            cursor: pointer;
            vertical-align: middle;
        }
        .module .module-ul .module-subheading .explain{
            display: block;
            width:5rem;
            position: absolute;
            border: 1px solid #1a96d4;
            border-radius: 10px;
            top:0.6rem;
            left:0;
            background-color: #fff;
            z-index:100;
            padding: 0.1rem 0.2rem;
            box-shadow:5px 5px 20px -5px #ccc
        }
        .module .module-ul .module-subheading .explain .icon-guanbi{
            position: absolute;
            top:5px;
            right:5px;
            font-size:0.3rem;
            cursor: pointer;
        }
        .module .module-ul .module-subheading .explain h1{
            font-size:0.3rem;
            color: #333;
        }
        .module .module-ul .module-subheading .explain p{
            font-size:0.24rem;
            color: #333;
        }
        .module .module-ul .module-li-choice{
            display: inline-block;
            width:100%;
            height:0.6rem;
            font-size:0.24rem;
            margin-top:0.2rem;
        }
        .module .module-ul .module-li-choice .choice{
            width:90%;
            height:0.6rem;
            text-align: center;
            line-height: 0.6rem;
            cursor: pointer;
            margin-left: 5%;
        }
        .module .module-ul .module-li-choice .choice.selected{
            border: 1px solid #1a96d4;
            color: #1a96d4;
            background-color: #d1edf8;
        }
        .module .module-ul .module-li-choice .choice-input{
            width:90%;
            height:0.6rem;
            text-align: center;
            line-height: 0.6rem;
            margin-left: 5%;
            padding: 0;
        }

        .btn{
            display: inline-block;
            width: 2rem;
            height: 0.6rem;
            font-size:0.36rem;
            line-height: 0.6rem;
            margin-top: 0.4rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/comprehensiveIncome.vue